import { APIMethod, fetchData } from "@client";

export async function removeLibraryElementQuery(elementId) {
  await fetchData(`/v1/library/${elementId}`, APIMethod.DELETE);
}
